// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1vczb","requiredAsterisk":"Info_requiredAsterisk__3PzGA"};